// Derives rail task lists (overdue/next-actions/unscheduled/planned) for PlanPage.
import { useMemo } from 'react';
import { addDays } from 'date-fns';
import { useTaskFilters } from '@/features/tasks/hooks/list/use-list-filters-view';
import { useNextActions } from '@/features/tasks/hooks/list/use-list-next-actions';
import { useProjectStates } from '@/features/tasks/hooks/status/use-project-states.js';
import { buildPlanRailTasks } from '@/features/planning/pages/planRailTasks';
import { buildRailSelectionHandlers } from '@/features/planning/pages/planPageLayoutHelpers';
import { RAIL_TASK_LIMIT } from '@/features/planning/pages/planPageConstants';

export function usePlanPageRailData({
  filteredTasks,
  tasksMap,
  planMode,
  setFocusOwnerId,
  setSelectedTaskIds,
}) {
  const railSelectionHandlers = useMemo(
    () => buildRailSelectionHandlers(setFocusOwnerId, setSelectedTaskIds),
    [setFocusOwnerId, setSelectedTaskIds],
  );

  const { overdueTasks, unscheduledTasks } = useTaskFilters(
    filteredTasks,
    tasksMap,
  );
  const nextActions = useNextActions();
  const { plannedParentIds, waitingForParentIds } = useProjectStates();
  const planRailTasks = useMemo(
    () => buildPlanRailTasks(planMode, filteredTasks),
    [planMode, filteredTasks],
  );
  const overdueRailSlice = useMemo(
    () => overdueTasks?.slice(0, RAIL_TASK_LIMIT) ?? [],
    [overdueTasks],
  );
  const nextActionRailSlice = useMemo(
    () => nextActions?.slice(0, RAIL_TASK_LIMIT) ?? [],
    [nextActions],
  );
  const weekDays = useMemo(
    () => Array.from({ length: 8 }, (_, i) => addDays(new Date(), i)),
    [],
  );

  return {
    railSelectionHandlers,
    overdueTasks,
    unscheduledTasks,
    nextActions,
    plannedParentIds,
    waitingForParentIds,
    planRailTasks,
    overdueRailSlice,
    nextActionRailSlice,
    weekDays,
  };
}
